import ENDPOINTS from 'api/endpoints';
import { doGet, doPut } from 'api/request';
import type {
  SmsCredentialsRequest,
  SmsCredentialsResponse,
} from 'api/resources/smsCredentials/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

const VERSION = 'v2';

export const getSmsCredentials = (
  accountId: string,
  projectId: string,
  integration: string,
) => {
  return doGet<SmsCredentialsResponse>(
    generateNextPath(ENDPOINTS.SMS_CREDENTIALS, {
      accountId,
      projectId,
      integration,
    }),
    LOGGER_TYPE.JUPITER,
    { version: VERSION },
  );
};

export const upsertSmsCredentials = ({
  accountId,
  projectId,
  request,
  integration,
}: {
  accountId: string;
  projectId: string;
  request: SmsCredentialsRequest;
  integration: string;
}) => {
  return doPut<SmsCredentialsResponse>(
    generateNextPath(ENDPOINTS.SMS_CREDENTIALS, {
      accountId,
      projectId,
      integration,
    }),
    LOGGER_TYPE.JUPITER,
    request,
    { version: VERSION },
  );
};
